export const queryGroupName = 'revenue';
